enum SORT_DIRECTIONS {
  UP = 'up',
  DOWN = 'down',
}

export default SORT_DIRECTIONS;
